module.exports = __webpack_public_path__ + "img/5_108.0caa760d.png";